import z from 'zod';

export type UnitWeightDto = {
	id: string;
	name: string;
	weight: number;
	source: string | null;
};

export const UnitWeightDtoSchema: z.ZodType<UnitWeightDto> = z.object({
	id: z.string(),
	name: z.string(),
	weight: z.number(),
	source: z.string().nullable(),
});
